import React from "react";
import { WHAT_TO_BRING } from "../../data/whatToBring";

export const WhatToBring = ({ testId = "what-to-bring" }) => (
  <div data-testid={testId} className="p-5 bg-cream-100 border border-bronze-light/30 rounded-md">
    <div className="eyebrow">What to bring</div>
    <ul className="mt-3 space-y-1.5 text-sm text-ink-muted">
      {WHAT_TO_BRING.map((x) => (
        <li key={x} className="flex gap-2"><span className="text-bronze-dark">•</span>{x}</li>
      ))}
    </ul>
  </div>
);
